import React, { memo, forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';

const PlotLineTip = forwardRef(({ text: propsText }, ref) => {
  const [show, toggleShow] = useState(false);
  const [text, setText] = useState(propsText);
  const [pos, setPos] = useState({});

  useImperativeHandle(ref, () => ({
    show(text, pos) {
      const { x, y } = pos;
      toggleShow(true);

      text && setText(text);
      if (x && y) {
        setPos({
          top: y - 16,
          left: x + 12,
        });
      }
    },

    hide() {
      toggleShow(false);
    },
  }));

  if (!show) {
    return null;
  }

  return (
    <div style={{ ...pos }} className="eps-plotline-tip" ref={ref}>
      <b style={{ color: '#DBDBDB' }}>{text?.metric}</b>:{' '}
      <span>{text?.num}</span>
    </div>
  );
});

PlotLineTip.propTypes = {
  text: PropTypes.number.isRequired,
};

export default memo(PlotLineTip);
